'use client'

import { LuneTheme, useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Text from '@mui/material/Typography'
import { FC } from 'react'

import LearnMoreTiles from '@/components/LearnMoreTiles'

const LogixboardResultTiles: FC<{}> = () => {
    const { xsScreen, smScreen, mdScreen } = useDevice()

    const { spacing } = LuneTheme
    return (
        <Box>
            <Stack
                sx={{
                    mb: {
                        xs: `${spacing(7)} !important`,
                        sm: `${spacing(7)} !important`,
                        md: `${spacing(9)} !important`,
                        lg: `${spacing(9)} !important`,
                        xl: `${spacing(9)} !important`,
                    },
                }}
                spacing={5}
            >
                <Text
                    variant={mdScreen ? 'h5' : 'h4'}
                    sx={{
                        textAlign: smScreen ? 'left' : 'center',
                    }}
                >
                    Result: Growing customer loyalty with an easy integration
                </Text>
                <Text
                    variant={mdScreen ? 'body2' : 'body1'}
                    sx={{
                        textAlign: smScreen ? 'left' : 'center',
                    }}
                >
                    {`The quick integration meant customers could start using their new green logistics feature immediately to win tenders, and Logixboard saw a return on their investment after just four months.`}
                </Text>
            </Stack>
            <LearnMoreTiles
                sx={{
                    ...(xsScreen
                        ? {}
                        : {
                              gap: 9,
                          }),
                }}
                renderOnSx={{
                    ...(xsScreen
                        ? {}
                        : {
                              flex: '0 0 calc(33% - 72px)',
                          }),
                }}
                tiles={[
                    {
                        title: <>Rapid time-to-wow </>,
                        icon: '/icons/icon-lead-innovation.png',
                        description:
                            'Logixboard engineers have dubbed Lune’s API as the easiest technical integration they’ve ever done.',
                    },
                    {
                        title: <>Growing customer value</>,
                        icon: '/icons/icon-high-quality-peace-1.png',
                        description: `With more deals in the pipeline, over thirty Logixboard customers are already paying for emission intelligence. It’s a value-added service with commercial traction.`,
                    },
                    {
                        title: <>Honouring commitments</>,
                        icon: '/icons/icon-easy-platform.png',
                        description:
                            'By opting for a modern, intelligent solution Logixboard fulfils its promise to its customers by futureproofing their business through the green transition.',
                    },
                ]}
            />
        </Box>
    )
}

export default LogixboardResultTiles
